import {
    createDevice,
    createLicensesMap,
    fetchDevice,
    fetchLicenses,
    generateLicenses,
    updateDevice,
    updateGroup,
} from "@dashboard/devices/store";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

const licensesActions = isAnyOf(
    fetchLicenses.fulfilled,
    generateLicenses.fulfilled,
    createDevice.fulfilled,
    fetchDevice.fulfilled,
    updateDevice.fulfilled,
    updateGroup.fulfilled,
);

export const initLicensesMapListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: licensesActions,
        effect: (action, listenerApi) => {
            if (fetchLicenses.fulfilled.match(action)) {
                listenerApi.dispatch(createLicensesMap());
            } else if (generateLicenses.fulfilled.match(action)) {
                listenerApi.dispatch(createLicensesMap(action.payload.map((license) => license.id)));
            } else if (createDevice.fulfilled.match(action)) {
                listenerApi.dispatch(createLicensesMap([action.payload.model.license.id]));
            } else if (fetchDevice.fulfilled.match(action)) {
                listenerApi.dispatch(createLicensesMap([action.payload.licenseId]));
            } else if (updateGroup.fulfilled.match(action)) {
                listenerApi.dispatch(createLicensesMap(action.payload.flatMap((group) => group.licenseIds)));
            } else if (updateDevice.fulfilled.match(action)) {
                // meta.arg only carries the device id, not its license id, so a targeted
                // rebuild isn't cheap here; a full rebuild is fine for this rare, user-triggered edit.
                listenerApi.dispatch(createLicensesMap());
            }
        },
    });
};
